import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import VisibilitySensor from 'react-visibility-sensor';
import { Container, Row, Col } from 'react-bootstrap';
import {
  SelectSubscriptionBoxes,
  SubscriptionSignupHeader,
  Testimonials,
  HomepageDescription,
  GetTheBox,
  HowItWorks,
  SocialProof,
  PastSubs,
  VisibilityPlaceholder,
  Loading,
} from '../../components';
import AsSeenIn from '../../components/asseenin';
import Hero from '../../components/hero';
import SchemaData from './SchemaData';
import './style.css';

// Services
import Environment from '../../services/Environment';
import CartUtils from '../../services/CartUtils';
import generalHelpers from '../../services/generalHelpers';

// Constants
import Content from '../../constants/Content';

class Home extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      provider: Environment.store,
      showMonthlyPlans: true,

      showSocialProof: false,
      showTestimonialsPlus: false,
      showPastSubs: false,
      showHowItWorks: false,
      showSelectSubs: false,
      modalType: 'NONE',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.match.params && this.props.match.params.referralCode) {
      localStorage.setItem(
        'referralCode',
        this.props.match.params.referralCode,
      );
    }
  }

  goToCart = () => {
    generalHelpers.goToCart(this.props);
  };

  handleAddPreCheckoutPromo = async (res) => {
    if (res) {
      this.setState(res);
      this.goToCart();
    }
  };

  nextStep = async (plan) => {
    this.setState({ isLoading: true });
    const res = await CartUtils.addSubscriptionToCart(
      plan,
      this.state.provider,
    );
    if (res) {
      this.setState({ ...res, modalType: 'PRE-CHECKOUT PROMO' });
    }
  };

  viewMonthlyPlans = () => {
    this.setState({ showMonthlyPlans: true });
  };

  viewBundledPlans = () => {
    this.setState({ showMonthlyPlans: false });
  };

  getTheBoxCtaClicked = () => {
    this.scrollToSubscriptionSelect();
  };

  heroSubscriptionCtaClicked = () => {
    this.scrollToSubscriptionSelect();
  };

  howItWorksCtaClicked = () => {
    this.scrollToSubscriptionSelect();
  };

  scrollToSubscriptionSelect = () => {
    const subscriptionRow = document.getElementById(
      'homepageSubscriptionSection',
    );

    if (subscriptionRow) {
      subscriptionRow.scrollIntoView();
    }
  };

  onVisibilityChange = (stateKey, isVisible) => {
    if (isVisible && !this.state[stateKey]) {
      this.setState({
        [stateKey]: true,
      });
    }
  };

  onVisibilitySocialProof = (isVisible) => {
    this.onVisibilityChange('showSocialProof', isVisible);
  };

  onVisibilityTestimonialsPlus = (isVisible) => {
    this.onVisibilityChange('showTestimonialsPlus', isVisible);
  };

  onVisibilityPastSubs = (isVisible) => {
    this.onVisibilityChange('showPastSubs', isVisible);
  };

  onVisibilityHowItWorks = (isVisible) => {
    this.onVisibilityChange('showHowItWorks', isVisible);
  };

  onVisibilitySelectSubs = (isVisible) => {
    this.onVisibilityChange('showSelectSubs', isVisible);
  };

  renderLoading = () => {
    if (this.state.isLoading) {
      return <Loading />;
    }

    return null;
  };

  render() {
    return (
      <Container className='mainPageContainer'>
        <Helmet>
          {/* Empty Helmet tag will inherit from the main app defaults. */}
        </Helmet>
        {this.renderLoading()}
        <Hero
          title={Content.home.title}
          subheading={Content.home.description}
          buttonText='SUBSCRIBE'
          handleScrollToElement={this.heroSubscriptionCtaClicked}
          stars
          defaultImage={{ default: `/hero.${Environment.store}.v1.jpg` }}
          layout='left'
        />
        <AsSeenIn />

        <Row
          id='homepageSubscriptionSection'
          className='selectSubscriptionContainer'
        >
          <Col>
            <VisibilitySensor
              offset={{ top: 25 }}
              partialVisibility
              onChange={this.onVisibilitySelectSubs}
              active={!this.state.showSelectSubs}
            >
              {this.state.showSelectSubs ? (
                <>
                  <SubscriptionSignupHeader
                    viewMonthlyPlans={this.viewMonthlyPlans}
                    viewBundledPlans={this.viewBundledPlans}
                    title={Content.subscriptionPlanSelection.title}
                    subtitle={Content.subscriptionPlanSelection.description}
                    showMonthlyPlans={this.state.showMonthlyPlans}
                    fullBackgroundColor={false}
                    subBoxContainerId='sub-wrapper'
                    urlPath={this.props.location.pathname}
                  />
                  <SelectSubscriptionBoxes
                    showMonthlyPlans={this.state.showMonthlyPlans}
                    nextStep={this.nextStep}
                    subBoxContainerId='sub-wrapper'
                    urlPath={this.props.location.pathname}
                    handleAddPreCheckoutPromo={this.handleAddPreCheckoutPromo}
                    modalType={this.state.modalType}
                    goToCart={this.goToCart}
                  />
                </>
              ) : (
                <VisibilityPlaceholder />
              )}
            </VisibilitySensor>
          </Col>
        </Row>
        <>
          <Row>
            <Col
              className='spaceBelow20 marginHorizontal10 center-align'
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ fontWeight: 'bold' }}
            >
              Your shipping and returns are FREE!
            </Col>
          </Row>
          <Row>
            <Col
              className='spaceBelow20 marginHorizontal10 center-align'
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              Monthly plans will renew after your final box is delivered.
              Charges may apply for early cancellation.
            </Col>
          </Row>
        </>
        <Row>
          <Col
            className='spaceBelow20 marginHorizontal10 center-align'
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            $9.99 will be applied for international shipping outside the US
            (Taxes & Duties Included)
          </Col>
        </Row>

        <VisibilitySensor
          offset={{ top: 50 }}
          partialVisibility
          onChange={this.onVisibilityHowItWorks}
          active={!this.state.showHowItWorks}
        >
          {this.state.showHowItWorks ? (
            <HowItWorks
              handleHowItWorksCtaClicked={this.howItWorksCtaClicked}
            />
          ) : (
            <VisibilityPlaceholder />
          )}
        </VisibilitySensor>

        {this.state.provider.includes('bump') ? (
          <VisibilitySensor
            offset={{ top: 50 }}
            partialVisibility
            onChange={this.onVisibilityPastSubs}
            active={!this.state.showPastSubs}
          >
            {this.state.showPastSubs ? <PastSubs /> : <VisibilityPlaceholder />}
          </VisibilitySensor>
        ) : null}

        <VisibilitySensor
          offset={{ top: 50 }}
          partialVisibility
          onChange={this.onVisibilityTestimonialsPlus}
          active={!this.state.showTestimonialsPlus}
        >
          {this.state.showTestimonialsPlus ? (
            <>
              <Testimonials title={Content.testimonials.title} />
              {Environment.store === 'bump' ? <HomepageDescription /> : null}
              <GetTheBox getTheBoxCtaClicked={this.getTheBoxCtaClicked} />
            </>
          ) : (
            <VisibilityPlaceholder />
          )}
        </VisibilitySensor>

        <VisibilitySensor
          offset={{ top: 50 }}
          partialVisibility
          onChange={this.onVisibilitySocialProof}
          active={!this.state.showSocialProof}
        >
          {this.state.showSocialProof ? (
            <SocialProof />
          ) : (
            <VisibilityPlaceholder />
          )}
        </VisibilitySensor>

        <SchemaData />
      </Container>
    );
  }
}

export default withRouter(Home);
